import { render, staticRenderFns } from "./VmagentebytypeGrid.vue?vue&type=template&id=d5a10b8e"
import script from "./VmagentebytypeGrid.vue?vue&type=script&lang=js"
export * from "./VmagentebytypeGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports